<template>
  <div>
    <ion-header>
      <ion-toolbar>
        <ion-title>Draw Your Signature</ion-title>
        <ion-buttons slot="start">
          <ion-button @click="onDone">Done</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="no-select">
      <div class="ion-padding">
        <span>Sign below</span>
      </div>
      <div
        class="signature-pad-modal-canvas-container"
        ref="signatureCanvasContainer"
      >
        <canvas
          class="signature-pad-modal-canvas"
          ref="signatureCanvas"
        ></canvas>
      </div>
    </ion-content>
  </div>
</template>

<script>
import SignaturePad from "signature_pad";
import trimCanvas from "trim-canvas";

function sizeCanvas(canvas, container) {
  const ratio = Math.max(window.devicePixelRatio || 1, 1);
  canvas.width = container.clientWidth * ratio;
  canvas.height = container.clientWidth * ratio;
  canvas.getContext("2d").scale(ratio, ratio);
}

function resizeCanvas(pad) {
  const ratio = Math.max(window.devicePixelRatio || 1, 1);
  pad.canvas.width = pad.canvas.offsetWidth * ratio;
  pad.canvas.height = pad.canvas.offsetHeight * ratio;
  pad.canvas.getContext("2d").scale(ratio, ratio);
  pad.clear(); // otherwise isEmpty() might return incorrect value
}

export default {
  name: "SignaturePadModal",
  props: ["onSignature"],
  mounted() {
    setTimeout(() => {
      let canvas = this.$refs.signatureCanvas;
      const canvasContainer = this.$refs.signatureCanvasContainer;
      if (canvas && canvasContainer) {
        sizeCanvas(canvas, canvasContainer);
        this.instance = new SignaturePad(canvas);
        this.resizeCanvas(this.instance);
        window.addEventListener("resize", this.resizeCanvas);
      }
    }, 200);
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeCanvas);
  },
  methods: {
    resizeCanvas() {
      if (this.instance) {
        resizeCanvas(this.instance);
      }
    },
    onDone() {
      if (this.instance) {
        trimCanvas(this.instance.canvas);
        const img = this.instance.toDataURL();
        if (typeof this.onSignature === "function") {
          this.onSignature(img);
        }
      }
      this.onClose();
    },
    onClose() {
      this.$ionic.modalController.dismiss();
    }
  }
};
</script>

<style lang="scss" scoped>
.signature-pad-modal {
  &-canvas-container {
    position: relative;
    width: 100%;
    height: 100%;
  }
  &-canvas {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
